import { useAuth } from '@/src/features/auth/use-auth';

import { LoadingView } from './LoadingView';
import { SessionRecoveryView } from './SessionRecoveryView';

type SessionLoadingViewProps = {
  allowRecovery?: boolean;
};

export function SessionLoadingView({
  allowRecovery = true,
}: SessionLoadingViewProps) {
  const { authInitSlow, authInitTimedOut } = useAuth();

  if (allowRecovery && authInitTimedOut) {
    return <SessionRecoveryView />;
  }

  return (
    <LoadingView
      message={
        authInitSlow
          ? 'Still checking your session...'
          : 'Checking your session...'
      }
    />
  );
}
